import { z } from 'zod';

const webEnvConfigSchema = z.object({
  api: z.object({
    baseURL: z.url(),
    timeout: z.number(),
    headers: z.record(z.string(), z.string()),
  }),
  env: z.enum(['development', 'production']),
  appEnv: z.enum(['local', 'dev', 'stage', 'prod']).default('local'),
  /** Public marketing website URL (e.g. the "Back to Home" / logo link from the login page). */
  websiteUrl: z.url().default('http://localhost:4201'),
  keycloak: z.object({
    authServerUrl: z.url('Keycloak auth server URL must be a valid URL'),
    realm: z.string().min(1, 'Keycloak realm is required'),
    clientId: z.string().min(1, 'Keycloak client ID is required'),
  }),
});

export const webEnvConfig = webEnvConfigSchema.parse(
  {
    api: {
      baseURL: import.meta.env.VITE_API_BASE_URL,
      timeout: 60000,
      headers: {
        'Content-Type': 'application/json',
      },
    },
    env: import.meta.env.MODE,
    appEnv: import.meta.env.VITE_APP_ENV,
    websiteUrl: import.meta.env.VITE_PUBLIC_WEBSITE_URL,
    keycloak: {
      authServerUrl: import.meta.env.VITE_KEYCLOAK_AUTH_SERVER_URL,
      realm: import.meta.env.VITE_KEYCLOAK_REALM,
      clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
    },
  },
  {
    error: (error) => {
      console.error(error);
      return 'Invalid config format, please check your .env file';
    },
  },
);
